import React from "react";
import { useTranslation } from "react-i18next";
import { KillSwitchModule } from "@/types/module-kill-switch";
import { MODULE_EFFECT_ITEMS } from "../utils/moduleLabels";

interface ModuleEffectsListProps {
  module: KillSwitchModule;
  compact?: boolean;
}

export const ModuleEffectsList: React.FC<ModuleEffectsListProps> = ({
  module,
  compact = false,
}) => {
  const { t } = useTranslation();
  const items = MODULE_EFFECT_ITEMS[module];

  // The backend is the source of truth for which kill-switch modules exist; if it
  // returns one the frontend hasn't catalogued yet, degrade gracefully (the card
  // still shows its label, status, and toggle) instead of crashing the page.
  if (!items) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <section className="flex flex-col gap-2">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {t("modules.states.whatDoesOffDo")}
        </h4>
        <ul
          className={
            compact
              ? "list-disc pl-5 text-sm text-foreground space-y-1"
              : "list-disc pl-5 text-sm text-foreground space-y-1.5"
          }
        >
          {items.disabled.map((key) => (
            <li key={key}>{t(key)}</li>
          ))}
        </ul>
      </section>

      <section className="flex flex-col gap-2">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {t("modules.states.whatIsNotAffected")}
        </h4>
        <ul className="list-disc pl-5 text-sm text-muted-foreground space-y-1">
          {items.notDisabled.map((key) => (
            <li key={key}>{t(key)}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};
